import React, { useState } from 'react'
import { AlertTitle, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Snackbar } from '@mui/material';
import axios from "axios"
import { Auth } from "aws-amplify";
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import FilterListIcon from '@mui/icons-material/FilterList';

import BarChart from '../../BarChart';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

const CompareReport = ({ facInfo }) => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [reportData, setReportData] = useState({})
  const [reportState, setReportState] = useState(false)
  const [compareState, setCompareState] = useState(true)
  const [reportError, setReportError] = useState("")
  const [testId, setTestId] = useState(["", ""])

  const [std, setStd] = useState("");
  const [divn, setDivn] = useState("");
  const [lang, setLang] = useState("");
  const [metric, setMetric] = useState("");

  const { t } = useTranslation();

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const handleTestIdChange = (index, testId) => {
    setCompareState(true)
    setTestId(prev => prev.map((oldTestId, i) => {
      if(i===index) return testId
      else return oldTestId
    }));
  };

  const handleStdChange = (e) => {
    setStd(e.target.value);
  };

  const handleDivnChange = (e) => {
    setDivn(e.target.value);
  };

  const handleLangChange = (e) => {
    let lang = e.target.value
    if(reportData!=="" && (Object.keys(reportData[testId[0]].report.class).includes(lang) || Object.keys(reportData[testId[1]].report.class).includes(lang))){
      setLang(lang);
      let stds = [...new Set(reportData[testId[0]].report.class[lang].map(item => item.std))].filter(item => 
                    [...new Set(reportData[testId[1]].report.class[lang].map(item => item.std))].includes(item)
                  ).sort((a, b) => a - b)
      if(!stds.includes(std)) setStd(stds[0])
      let divns = [...new Set(reportData[testId[0]].report.class[lang].filter(item => item.std === std).map(item => item.divn))].filter(item => 
                      [...new Set(reportData[testId[1]].report.class[lang].filter(item => item.std === std).map(item => item.divn))].includes(item)
                    ).sort()
      if(!divns.includes(std)) setDivn(divns[0])
      let metrics = Object.keys(reportData["metric"][lang])
      if(!metrics.includes(metric)){
        setMetric(metrics[0])
        // setChartType(reportData["metric"][lang][metrics[0]][0])
      }
    }
    else if(reportData!==""){
      setReportError(t("facilitator.results.compareTab.error_api_resultNotFoundLang"))
      setCompareState(true)
    }
  };

  const handleMetricChange = (e) => {
    // if(reportData!==""){
    //     let chartTypes = reportData["metric"][lang][e.target.value]
    //     if(!chartTypes.includes(chartType)) setChartType(chartTypes[0])
    // }
    setMetric(e.target.value);
  };

  var filteredReportData = ""
  if(lang && std!== "" && divn!== "" && !compareState && (Object.keys(reportData[testId[0]].report.class).includes(lang) || Object.keys(reportData[testId[1]].report.class).includes(lang))) filteredReportData = {
    [testId[0]] : {
      "class": reportData[testId[0]].report.class[lang].filter(item => item.std === std && item.divn === divn)[0],
      "thresholds": reportData[testId[0]].report.thresholds[lang].filter(item => item.std === std)[0]
    },
    [testId[1]] : {
      "class": reportData[testId[1]].report.class[lang].filter(item => item.std === std && item.divn === divn)[0],
      "thresholds": reportData[testId[1]].report.thresholds[lang].filter(item => item.std === std)[0]
    }
  }

  const handleCompare = () => {

    if(!facInfo.allTests && facInfo.allTests.length===1){
      setToastType(["warning", t("facilitator.results.compareTab.error_notEnoughTest")])
      setToastOpen(true)
      return
    }

    if(!(testId[0]) || !(testId[1])) {
      setToastType(["warning", t("commonItems.error_requiredFields")])
      setToastOpen(true)
      return
    }

    const testId1 = String(testId[0])
    const testId2 = String(testId[1])

    let oldTestIds = Object.keys(reportData)
    let newTestIds = []

    if(!oldTestIds.includes(testId1)) newTestIds.push(testId1)
    if(!oldTestIds.includes(testId2)) newTestIds.push(testId2)

    // console.log(oldTestIds)
    // console.log(testId1, testId2)
    // console.log(newTestIds)

    setReportError("")
    if(newTestIds.length){
      setReportState(true)
      const facId = facInfo.facilitator[0].facId
      const classId = facInfo.facilitator[0].schools[0].classes[0].classId
      Auth.currentSession()
      .then(async (data) => {
        const jwtToken = data.idToken.jwtToken;
  
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/facilitator/"+facId+"/compare-result?classId="+classId+"&testId="+testId.toString()+"&ver=2", {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': jwtToken
            }
          });
          // console.log("get Response: ",response.data)
          // Remove keys from the metric object
          // let metricFilters = []
          let metricFilters = ["pace", "accuracy"]
          let filteredMetric = Object.fromEntries(
              Object.entries(response.data.report.metric).map(([metricLang, metrics]) => {
                  let filtered = Object.fromEntries(
                      Object.entries(metrics).filter(([key]) => !metricFilters.includes(key))
                    );
                    return [metricLang, filtered];
                  })
                );
          const responseData = {...response.data["report"],
            "metric": filteredMetric
          }
          setReportData({...responseData})
          let selectedTestLangs = facInfo.allTests.filter(item => item.testId === testId[0])[0].lang.filter(lan => 
            facInfo.allTests.filter(item => item.testId === testId[1])[0].lang.includes(lan)
          )
          let selectedLang = selectedTestLangs.sort()[0]
          if(!selectedTestLangs.includes(lang)) setLang(selectedLang)
          const std1 = [...new Set(responseData[testId[0]].report.class[selectedLang].map(item => item.std))].filter(item => 
                          [...new Set(responseData[testId[1]].report.class[selectedLang].map(item => item.std))].includes(item)
                        ).sort((a, b) => a - b)[0]
          setStd(std1)
          setDivn([...new Set(responseData[testId[0]].report.class[selectedLang].filter(item => item.std === std1).map(item => item.divn))].filter(item => 
            [...new Set(responseData[testId[1]].report.class[selectedLang].filter(item => item.std === std1).map(item => item.divn))].includes(item)
          ).sort()[0])
          let metric = Object.keys(responseData.metric[selectedLang])[0]
          setMetric(metric)
          // setChartType(responseData.metric[selectedLang][metric][0])
          setReportState(false)
          setCompareState(false)
        }
        catch (error) {
          // console.log(error)
          if(error.response.status === 404) setReportError(t("facilitator.results.compareTab.error_api_resultNotFound"))
          else{
            console.log(error)
            setToastType(["error", t("commonItems.error_api_generic")])
            setToastOpen(true)
          }
          setReportState(false)
        }
      })
      .catch((err) => console.log(err));
    }
    else setCompareState(false)
  }

  return (
    <>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <div className="filters" style={{flexDirection: "column", alignItems: "unset"}}>
        <div className="forms">
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="test1FilterLabel">{t("facilitator.results.compareTab.dropdownLabel_test1")}</InputLabel>
            <Select
              labelId="test1FilterLabel"
              id="test1Filter"
              value={testId[0] ? testId[0] : ""}
              onChange={(e) => handleTestIdChange(0, e.target.value)}
              autoWidth
              label={t("facilitator.results.compareTab.dropdownLabel_test1")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {facInfo.allTests &&
                facInfo.allTests.filter(item => item.status === 3).map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={facInfo.allTests[i].testId} disabled={testId[1] === facInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="test2FilterLabel">{t("facilitator.results.compareTab.dropdownLabel_test2")}</InputLabel>
            <Select
              labelId="test2FilterLabel"
              id="test2Filter"
              value={testId[1] ? testId[1] : ""}
              onChange={(e) => handleTestIdChange(1, e.target.value)}
              autoWidth
              label={t("facilitator.results.compareTab.dropdownLabel_test2")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {facInfo.allTests &&
                facInfo.allTests.filter(item => item.status === 3).map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={facInfo.allTests[i].testId} disabled={testId[0] === facInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          {reportState 
            ?
            <Button color="info" variant="contained" disabled sx={{m: 1}}>{t("facilitator.results.compareTab.buttonLabel_compare")}<CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/></Button>
            :
            <Button color="info" variant="contained" onClick={handleCompare} sx={{m: 1}}>{t("facilitator.results.compareTab.buttonLabel_compare")}</Button>
          }
        </div>
        {!compareState ?
          <div className="forms">
            <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
              <FilterListIcon fontSize="small"/>
              <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
            </h4>
            <FormControl sx={{ m: 1, minWidth: 150}} size="small">
              <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
              <Select
                labelId="langFilterLabel"
                id="langFilter"
                value={lang}
                onChange={handleLangChange}
                autoWidth
                label={t("commonItems.dropdownLabel_lang")}
              >
                { facInfo.allTests &&
                  facInfo.allTests.filter(item => item.testId === testId[0])[0].lang.filter(lan => 
                    facInfo.allTests.filter(item => item.testId === testId[1])[0].lang.includes(lan)
                  ).sort().map((item, i) => {
                    return <MenuItem key={i} value={item}>{facInfo.allLangs[item]}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 85}} size="small">
              <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
              <Select
                labelId="stdFilterLabel"
                id="stdFilter"
                value={std}
                onChange={handleStdChange}
                autoWidth
                label={t("commonItems.dropdownLabel_class")}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                {/* getting all unique std values from data */}
                { Object.keys(reportData).length && lang &&
                  [...new Set(reportData[testId[0]].report.class[lang].map(item => item.std))].filter(item => 
                    [...new Set(reportData[testId[1]].report.class[lang].map(item => item.std))].includes(item)
                  ).sort((a, b) => a - b).map((item, i) => {
                  return <MenuItem key={i} value={item}>{item}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 85}} size="small">
              <InputLabel id="divnFilterLabel">{t("commonItems.dropdownLabel_section")}</InputLabel>
              <Select
                labelId="divnFilterLabel"
                id="divnFilter"
                value={divn}
                onChange={handleDivnChange}
                autoWidth
                label={t("commonItems.dropdownLabel_section")}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                {/* getting all unique std values from data */}
                { Object.keys(reportData).length && lang &&
                  [...new Set(reportData[testId[0]].report.class[lang].filter(item => item.std === std).map(item => item.divn))].filter(item => 
                    [...new Set(reportData[testId[1]].report.class[lang].filter(item => item.std === std).map(item => item.divn))].includes(item)
                  ).sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{item}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 120}} size="small">
              <InputLabel id="metricFilterLabel">{t("commonItems.dropdownLabel_metric")}</InputLabel>
              <Select
                labelId="metricFilterLabel"
                id="metricFilter"
                value={metric}
                onChange={handleMetricChange}
                autoWidth
                label={t("commonItems.dropdownLabel_metric")}
              >
                { reportData!=="" && lang &&
                  Object.keys(reportData["metric"][lang]).map((item, i) => {
                    return <MenuItem key={i} value={item}>{
                      item==="wcpm" ? "WCPM" : 
                      item==="phrasing" ? "Phrasing" : 
                      item==="pace" ? "Pace" :
                      item==="accuracy" ? "Accuracy" :
                      item 
                    }</MenuItem>
                  })
                }
              </Select>
            </FormControl>
          </div>
        :
          <MuiAlert severity="info" className="uploadInstructions" style={{marginTop: "0.5rem"}}>
            <AlertTitle><b>{t("facilitator.results.compareTab.noTestSelectedInfo")}</b></AlertTitle>
          </MuiAlert>
        }
      </div>
      <div className="charts">
        {!reportError ? 
          <>
            {filteredReportData && !compareState &&
              <>
                {metric === "wcpm" &&
                  <BarChart
                    chartData = {
                      [
                        [filteredReportData[testId[0]].class.wcpmCat1, filteredReportData[testId[0]].class.wcpmCat2, filteredReportData[testId[0]].class.wcpmCat3, filteredReportData[testId[0]].class.wcpmCat4, filteredReportData[testId[0]].class.wcpmCat5, filteredReportData[testId[0]].class.wcpmTotal],
                        [filteredReportData[testId[1]].class.wcpmCat1, filteredReportData[testId[1]].class.wcpmCat2, filteredReportData[testId[1]].class.wcpmCat3, filteredReportData[testId[1]].class.wcpmCat4, filteredReportData[testId[1]].class.wcpmCat5, filteredReportData[testId[1]].class.wcpmTotal]
                      ]
                    }
                    catLabelData={
                      [
                        filteredReportData[testId[0]].thresholds.wcpmT1 < 0 ? "Invalid Entries" : t("commonItems.chartCatLabel_bar_wcpm1", {t1: 0, t2: filteredReportData[testId[0]].thresholds.wcpmT1}),
                        t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT1+1, t2: filteredReportData[testId[0]].thresholds.wcpmT2}),
                        t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT2+1, t2: filteredReportData[testId[0]].thresholds.wcpmT3}),
                        filteredReportData[testId[0]].thresholds.wcpmT4 < 0 ?  t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData[testId[0]].thresholds.wcpmT3+1}) : t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT3+1, t2: filteredReportData[testId[0]].thresholds.wcpmT4}),
                        filteredReportData[testId[0]].thresholds.wcpmT4 < 0 ? "-" : t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData[testId[0]].thresholds.wcpmT4+1})
                      ]
                    }
                    labelData = {[
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[0])[0].testName}), 
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[1])[0].testName})
                                ]}
                    title = {"WCPM - " + t("facilitator.results.compareTab.chartTitle") + " - " + facInfo.allLangs[lang]} 
                    xLabel = {t("facilitator.results.compareTab.chartXLabel", {std: std})}
                    yLabel = {t("facilitator.results.compareTab.chartYLabel", {unit: "%"})}
                  />
                }
                {metric === "phrasing" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("phrasingT1") ?
                      <BarChart
                        chartData = { 
                          [
                            [filteredReportData[testId[0]].class.phrasingNotQualified, filteredReportData[testId[0]].class.phrasingCat1, filteredReportData[testId[0]].class.phrasingCat2, filteredReportData[testId[0]].class.phrasingCat3, filteredReportData[testId[0]].class.phrasingCat4, filteredReportData[testId[0]].class.phrasingTotal],
                            [filteredReportData[testId[1]].class.phrasingNotQualified, filteredReportData[testId[1]].class.phrasingCat1, filteredReportData[testId[1]].class.phrasingCat2, filteredReportData[testId[1]].class.phrasingCat3, filteredReportData[testId[1]].class.phrasingCat4, filteredReportData[testId[1]].class.phrasingTotal]
                          ]
                        }
                        catLabelData={
                          [
                            // "Phrasing > " + filteredReportData.thresholds.enPhrasingScoreT1,
                            // "Phrasing between " + (filteredReportData.thresholds.enPhrasingScoreT2) + " - " + filteredReportData.thresholds.enPhrasingScoreT1,
                            // "Phrasing between 0 - " + filteredReportData.thresholds.enPhrasingScoreT2
                            t("commonItems.chartCatLabel_bar_phrasing1"), 
                            t("commonItems.chartCatLabel_bar_phrasing2"), 
                            t("commonItems.chartCatLabel_bar_phrasing3"), 
                            t("commonItems.chartCatLabel_bar_phrasing4"), 
                            t("commonItems.chartCatLabel_bar_phrasing5")
                          ]  
                        }
                        labelData = {[
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[0])[0].testName}), 
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[1])[0].testName})
                                ]}
                        title = {"Phrasing - " + t("facilitator.results.compareTab.chartTitle") + " - " + facInfo.allLangs[lang]} 
                        xLabel = {t("facilitator.results.compareTab.chartXLabel", {std: std})}
                        yLabel = {t("facilitator.results.compareTab.chartYLabel", {unit: "%"})}
                        // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Phrasing"})}</h3>
                    }
                  </>
                }
                {metric === "pace" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("paceT1") ?
                      <BarChart
                        chartData = { 
                          [
                            [filteredReportData[testId[0]].class.paceCat1, filteredReportData[testId[0]].class.paceCat2, filteredReportData[testId[0]].class.paceCat3, filteredReportData[testId[0]].class.paceCat4, filteredReportData[testId[0]].class.paceTotal],
                            [filteredReportData[testId[1]].class.paceCat1, filteredReportData[testId[1]].class.paceCat2, filteredReportData[testId[1]].class.paceCat3, filteredReportData[testId[1]].class.paceCat4, filteredReportData[testId[1]].class.paceTotal]
                          ]
                        }
                        labelData = {[
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[0])[0].testName}), 
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[1])[0].testName})
                                ]}
                        catLabelData={
                          [
                            // "Slow", "Medium", "Fast", "Very Fast"
                            t("commonItems.chartCatLabel_bar_pace1", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT1) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace2", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT1) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData[testId[0]].thresholds.paceT2) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace3", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT2) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData[testId[0]].thresholds.paceT3) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace4", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT3) + 0.1).toFixed(1)})
                          ]
                        }
                        title = {"Pace - " + t("facilitator.results.compareTab.chartTitle") + " - " + facInfo.allLangs[lang]} 
                        xLabel = {t("facilitator.results.compareTab.chartXLabel", {std: std})}
                        yLabel = {t("facilitator.results.compareTab.chartYLabel", {unit: "%"})}
                        // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Pace"})}</h3>
                    }
                  </>
                }
                {metric === "accuracy" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("accuracyT1") ?
                      <BarChart
                        chartData = { 
                          [
                            [filteredReportData[testId[0]].class.accuracyCat1, filteredReportData[testId[0]].class.accuracyCat2, filteredReportData[testId[0]].class.accuracyCat3, filteredReportData[testId[0]].class.accuracyCat4, filteredReportData[testId[0]].class.accuracyTotal],
                            [filteredReportData[testId[1]].class.accuracyCat1, filteredReportData[testId[1]].class.accuracyCat2, filteredReportData[testId[1]].class.accuracyCat3, filteredReportData[testId[1]].class.accuracyCat4, filteredReportData[testId[1]].class.accuracyTotal]
                          ]
                        }
                        labelData = {[
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[0])[0].testName}), 
                                  t("facilitator.results.compareTab.chartLabel1", {test: facInfo.allTests.filter(item => item.testId === testId[1])[0].testName})
                                ]}
                        catLabelData={
                          [
                            // "Poor", "Fair", "Good", "Excellent"
                            t("commonItems.chartCatLabel_bar_accuracy1", {t1: (filteredReportData[testId[0]].thresholds.accuracyT1+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy2", {t1: (filteredReportData[testId[0]].thresholds.accuracyT1+1), t2: (filteredReportData[testId[0]].thresholds.accuracyT2+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy3", {t1: (filteredReportData[testId[0]].thresholds.accuracyT2+1), t2: (filteredReportData[testId[0]].thresholds.accuracyT3+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy4", {t1: (filteredReportData[testId[0]].thresholds.accuracyT3+1)})
                          ]
                        }
                        title = {"Accuracy - " + t("facilitator.results.compareTab.chartTitle") + " - " + facInfo.allLangs[lang]} 
                        xLabel = {t("facilitator.results.compareTab.chartXLabel", {std: std})}
                        yLabel = {t("facilitator.results.compareTab.chartYLabel", {unit: "%"})}
                        // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Accuracy"})}</h3>
                    }
                  </>
                }
              </>
            }
            {reportState && compareState && <CircularProgress color="info" sx={{placeSelf: "center"}}/> }
          </>
        : <h3 style={{placeSelf: "center"}}>{reportError}</h3>
      }
      </div>
    </>
  )
}

export default CompareReport